<div
  class="toast bg-background flex-center rounded-md p-4"
  [@toastAnimation]="closing ? 'closing' : 'open'"
  (@toastAnimation.done)="onAnimationDone($event)"
>
  <span
    class="toast__icon flex flex-center rounded-100"
    [ngClass]="toast.type === 'success' ? 'bg-success text-white' : 'bg-error text-white'"
  >
    {{ toast.type === 'success' ? '✔' : '⚠' }}
  </span>
  <div class="toast__message font-sm pl-4">{{ toast.text }}</div>
  <button class="toast__close text-muted font-md pr-2 hover:text-error ml-4" (click)="startClosing()">✖</button>
</div>
